import { isEmpty } from 'lodash-es';
import { TaskCenterTypes } from '@frontend/api-task-center';
import { emptyStateGraphics } from '@frontend/design-system';
import { SelectedFilters } from '../types';

export const getTaskEmptyState = (status: TaskCenterTypes.TaskStatus): keyof typeof emptyStateGraphics => {
  switch (status) {
    case TaskCenterTypes.TaskStatus.STATUS_TODO:
      return 'taskTodo';
    case TaskCenterTypes.TaskStatus.STATUS_IN_PROGRESS:
      return 'taskInProgress';
    case TaskCenterTypes.TaskStatus.STATUS_COMPLETED:
      return 'taskCompleted';
    default:
      return 'taskTodo';
  }
};

export const isFiltersApplied = (filters: SelectedFilters): boolean => {
  for (const key in filters) {
    const value = filters[key as keyof SelectedFilters];
    if (key !== 'locations' && !isEmpty(value)) {
      return true;
    }
  }
  return false;
};
